import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { useIsMobile } from '../util/use-mobile';
import Header from './Header';
import Footer from './Footer';
import LoadingSpinner from '../components/ui/LoadingSpinner';
import BaseLayout from './BaseLayout';
import TabBar from './TabBar';

/**
 * 메인 레이아웃
 *
 * @author hjkim
 * @constructor
 */
const MainLayout = () => {
  /**
   * Hooks
   */
  const isMobile = useIsMobile();
  const isFetching = useIsFetching({
    predicate: (query) => !query.meta?.hideGlobalLoader,
  });
  const isMutating = useIsMutating({
    predicate: (mutation) => !mutation.meta?.hideGlobalLoader,
  });
  const isLoading = isFetching > 0 || isMutating > 0;

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <LoadingSpinner isPending={isLoading} delay={300} />
      {/* 메인 헤더 부분 */}
      <Header />
      {/* 메인 콘텐츠 부분 */}
      <BaseLayout />
      {/* 메인 푸터 부분 */}
      {/* 모바일: 하단 가로 탭바 / 데스크톱: 우측 세로 도크 (임시) */}
      {isMobile ? <TabBar /> : <TabBar variant="desktop" />}
      <Footer />
      <Toaster />
    </div>
  );
};

export default MainLayout;
